"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 获取是否开启 https 对象链接
 * @param secure 是否开启 htttps
 * @param url 对象上传路径
 */
function initClient(SDK, config) {
    var region = config.region, accessKeyId = config.accessKeyId, accessKeySecret = config.accessKeySecret, stsToken = config.stsToken, bucket = config.bucket, secure = config.secure;
    return new SDK({
        region: region,
        accessKeyId: accessKeyId,
        accessKeySecret: accessKeySecret,
        stsToken: stsToken,
        bucket: bucket,
        secure: secure
    });
}
/**
 * 分段上传
 * @param client SDK实例
 * @param file 需要上传的文件
 * @param uploadConfig 上传配置
 * @param userConfig 实例的配置
 * @returns Promise
 */
function upload(client, file, uploadConfig, userConfig) {
    return new Promise(function (resolve, reject) {
        client.multipartUpload(userConfig.key, file, __assign({ headers: userConfig.headers }, uploadConfig)).then(function (_a) {
            var res = _a.res;
            var _b = res, status = _b.status, requestUrls = _b.requestUrls;
            if (status === 200) {
                // 处理返回需要的参数，目前只用到了上传成功之后的链接
                resolve({
                    status: status,
                    data: {
                        url: requestUrls[0].split('?uploadId=')[0],
                        key: requestUrls[0].split('aliyuncs.com/')[1].split('?uploadId=')[0]
                    }
                });
            }
            else {
                reject({
                    error: {
                        message: '上传失败'
                    }
                });
            }
        });
    });
}
/**
 * 图片处理
 * @param url 图片链接
 * @param config 配置参数
 * @returns 返回图片处理 url 拼接字符串
 */
function processImage(url, config) {
    var processURL = url + "?x-oss-process=image/resize,w_" + config.resize.w;
    if (config.resize.h) {
        processURL += ",h_" + config.resize.h;
    }
    return processURL;
}
exports.default = {
    initClient: initClient,
    upload: upload,
    processImage: processImage
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3NzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9vc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUVBOzs7O0dBSUc7QUFDSCxTQUFTLFVBQVUsQ0FBQyxHQUFRLEVBQUUsTUFBbUI7SUFDdkMsSUFBQSxzQkFBTSxFQUFFLGdDQUFXLEVBQUUsd0NBQWUsRUFBRSwwQkFBUSxFQUFFLHNCQUFNLEVBQUUsc0JBQU0sQ0FBVztJQUNqRixPQUFPLElBQUksR0FBRyxDQUFDO1FBQ2IsTUFBTSxRQUFBO1FBQ04sV0FBVyxhQUFBO1FBQ1gsZUFBZSxpQkFBQTtRQUNmLFFBQVEsVUFBQTtRQUNSLE1BQU0sUUFBQTtRQUNOLE1BQU0sUUFBQTtLQUNQLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRDs7Ozs7OztHQU9HO0FBQ0gsU0FBUyxNQUFNLENBQUMsTUFBVyxFQUFFLElBQVUsRUFBRSxZQUFtQyxFQUFFLFVBQXVCO0lBQ25HLE9BQU8sSUFBSSxPQUFPLENBQUMsVUFBQyxPQUFPLEVBQUUsTUFBTTtRQUNqQyxNQUFNLENBQUMsZUFBZSxDQUFDLFVBQVUsQ0FBQyxHQUFHLEVBQUUsSUFBSSxhQUN6QyxPQUFPLEVBQUUsVUFBVSxDQUFDLE9BQU8sSUFDeEIsWUFBWSxFQUNmLENBQUMsSUFBSSxDQUFDLFVBQUMsRUFBTztnQkFBTCxZQUFHO1lBQ04sSUFBQSxRQUFvQyxFQUFsQyxrQkFBTSxFQUFFLDRCQUEwQixDQUFBO1lBQzFDLElBQUksTUFBTSxLQUFLLEdBQUcsRUFBRTtnQkFDbEIsNEJBQTRCO2dCQUM1QixPQUFPLENBQUM7b0JBQ04sTUFBTSxRQUFBO29CQUNOLElBQUksRUFBRTt3QkFDSixHQUFHLEVBQUUsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLENBQUM7d0JBQzFDLEdBQUcsRUFBRSxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLENBQUM7cUJBQ3JFO2lCQUNGLENBQUMsQ0FBQTthQUNIO2lCQUFNO2dCQUNMLE1BQU0sQ0FBQztvQkFDTCxLQUFLLEVBQUU7d0JBQ0wsT0FBTyxFQUFFLE1BQU07cUJBQ2hCO2lCQUNGLENBQUMsQ0FBQTthQUNIO1FBQ0gsQ0FBQyxDQUFDLENBQUE7SUFDSixDQUFDLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRDs7Ozs7R0FLRztBQUNILFNBQVMsWUFBWSxDQUFDLEdBQVcsRUFBRSxNQUEwQjtJQUMzRCxJQUFJLFVBQVUsR0FBTSxHQUFHLHNDQUFpQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUcsQ0FBQTtJQUN6RSxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFO1FBQ25CLFVBQVUsSUFBSSxRQUFNLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBRyxDQUFBO0tBQ3RDO0lBQ0QsT0FBTyxVQUFVLENBQUE7QUFDbkIsQ0FBQztBQUdELGtCQUFlO0lBQ2IsVUFBVSxZQUFBO0lBQ1YsTUFBTSxRQUFBO0lBQ04sWUFBWSxjQUFBO0NBQ2IsQ0FBQSJ9